import { BRAND } from '@/lib/brand';
/**
 * Customer quotes, shared by the sign-up page's proof panel and the trial
 * page. Keep them in step with the website's proof band when it changes.
 */
export interface Testimonial {
  quote: string;
  name: string;
  role: string;
  company: string;
  avatar: string;
  /** A headline number for the sign-up panel; quotes without one skip it. */
  metric?: { value: string; label: string };
}

export const TESTIMONIALS: Testimonial[] = [
  {
    quote: `Our entire GTM team lives off ${BRAND.name} now. We replaced 5+ tools, deals are 30% bigger, and reps are doing 50% more volume.`,
    name: 'Ruslan Valeev',
    role: 'Senior Director, Revenue Operations',
    company: 'Float',
    avatar: '/logos/ruslan-valeev.jpeg',
    metric: { value: '5+', label: 'Tools replaced' },
  },
  {
    quote:
      'Speed to lead is now minutes with perfect data quality. We doubled inbound deals and convert 30% better.',
    name: 'Evan Santa',
    role: 'VP of Sales',
    company: 'Proposify',
    avatar: '/logos/evan-santa.jpeg',
    metric: { value: '2x', label: 'Inbound deals' },
  },
  {
    quote: `${BRAND.name} gives us the highest accuracy data in our entire waterfall. Pickup rates went from 8% to 13%.`,
    name: 'Hayk Ghon',
    role: 'GTM Lead',
    company: 'Warp',
    avatar: '/logos/hayk-ghon.jpeg',
    metric: { value: '8→13%', label: 'Pickup rate' },
  },
  {
    quote:
      'Kindsight builds and runs plays with Clu automatically. Accounts in, the right people found at each one, enriched, verified, and synced under the owner who was just assigned.',
    name: 'Thomas Wei',
    role: 'Senior Manager, Revenue Operations',
    company: 'Kindsight',
    avatar: '/logos/thomas-wei.jpeg',
  },
];

/** How long each quote stays up before the next. */
export const TESTIMONIAL_ROTATE_MS = 7000;
